/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelGetProjectRequest,
  ModelGetProjectResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ProjectDetail<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get project detail
   *
   * @tags project
   * @name ProjectDetailCreate
   * @summary get project detail
   * @request POST:/projectDetail
   */
  projectDetailCreate = (
    request: ModelGetProjectRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelGetProjectResponse, any>({
      path: `/projectDetail`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
